export const actionFilters = [
    {
        filter: {
            type: 'model_created',
        },
        name: 'Inbox Created',
    },
    {
        filter: {
            attribute: 'name',
            type: 'model_updated',
        },
        name: 'Name Changed',
    },
    {
        filter: {
            attribute: 'description',
            type: 'model_updated',
        },
        name: 'Description Changed',
    },
    {
        filter: {
            attribute: 'dial_mode',
            type: 'model_updated',
        },
        name: 'Dial Mode Changed',
    },
    {
        filter: {
            attribute: 'text_assign_mode',
            type: 'model_updated',
        },
        name: 'Text Assignment Mode Changed',
    },
    {
        filter: {
            attribute: 'should_queue',
            type: 'model_updated',
        },
        name: 'Smart Queue Changed',
    },
    {
        filter: {
            attribute: 'fishing_mode',
            type: 'model_updated',
        },
        name: 'Fishing Mode Changed',
    },
    {
        filter: {
            attribute: 'max_wait_time',
            type: 'model_updated',
        },
        name: 'Max Wait Time Changed',
    },
    {
        filter: {
            attribute: 'repeat_contact_route_to',
            type: 'model_updated',
        },
        name: 'Repeat Contact Routing Changed',
    },
    {
        filter: {
            attribute: 'enable_sms_notifications',
            type: 'model_updated',
        },
        name: 'SMS Notifications Changed',
    },
    {
        filter: {
            attribute: 'enable_voicemail_notifications',
            type: 'model_updated',
        },
        name: 'Voicemail Notifications Changed',
    },
    {
        filter: {
            attribute: 'enable_watcher_email_notifications',
            type: 'model_updated',
        },
        name: 'Watcher Email Notifications Changed',
    },
    {
        filter: {
            type: 'relation_created',
        },
        name: 'User/Team Added',
    },
    {
        filter: {
            type: 'relation_deleted',
        },
        name: 'User/Team Removed',
    }
];

export const textConfigs = [
    {
        match: {
            event_type: 'model_created'
        },
        text: '`Inbox <strong>${audit.changes.name}</strong> was created by <strong>${audit.user?audit.user.name:\'No user\'}</strong>`',
        icon: 'added_team'
    },
    {
        match: {
            event_type: 'model_deleted'
        },
        text: '`The Inbox was deleted by <strong>${audit.user?audit.user.name:\'No user\'}</strong>`',
        icon: 'deleted_team'
    },
    {
        match: {
            event_type: 'relation_created'
        },
        text: '`${audit.label.startsWith("add_user") ? "User" : "Team"} <strong>${audit.label.startsWith("add_user") ? `${audit.related.first_name} ${audit.related.last_name}` : `${audit.related.name}`}</strong> was added to ${audit.label.includes("layer") ? `<strong>Layer ${audit.label.split("_").pop()}</strong>` : "" } inbox`',
        icon: '`${audit.label.startsWith("add_user") ? "added_user" : "added_team"}`'
    },
    {
        match: {
            label: 'add_watcher_user'
        },
        text: '`Watcher User <strong>${audit.related.name}</strong> was added to inbox`',
        icon: 'added_watcher'
    },
    {
        match: {
            label: 'add_watcher_team'
        },
        text: '`Watcher Team <strong>${audit.related.name}</strong> was added to inbox`',
        icon: 'added_watcher'
    },
    {
        match: {
            event_type: 'relation_deleted'
        },
        text: '`${audit.label.startsWith("remove_user") ? "User" : "Team"} <strong>${audit.label.startsWith("remove_user") ? `${audit.related.first_name} ${audit.related.last_name}` : `${audit.related.name}`}</strong> was removed from ${audit.label.includes("layer") ? `<strong>Layer ${audit.label.split("_").pop()}</strong>` : "" } inbox`',
        icon: '`${audit.label.startsWith("remove_user") ? "deleted_user" : "deleted_team"}`'
    },
    {
        match: {
            label: 'remove_watcher_user'
        },
        text: '`Watcher User <strong>${audit.related.name}</strong> was removed from inbox`',
        icon: 'deleted_watcher'
    },
    {
        match: {
            label: 'remove_watcher_team'
        },
        text: '`Watcher Team <strong>${audit.related.name}</strong> was removed from inbox`',
        icon: 'deleted_watcher'
    },
    {
        match: {
            attribute: 'name'
        },
        text: '`Name changed from "<strong>${change[0]}</strong>" to "<strong>${change[1]}</strong>"`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'description'
        },
        text: '`Description changed from "<strong>${change[0]}</strong>" to "<strong>${change[1]}</strong>"`',
        icon: 'description_changed'
    },
    {
        match: {
            attribute: 'dial_mode'
        },
        text: '`Dial mode changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'text_assign_mode'
        },
        text: '`Text assignment mode changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'should_queue'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} Smart queue`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'fishing_mode'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} Fishing mode`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'experimental_fishing_mode_repeat_call_routing'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} Contact owner priority routing`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'call_waiting'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} Call waiting`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'max_wait_time'
        },
        text: '`Maximum wait time changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong> seconds`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'repeat_contact_route_to'
        },
        text: '`Repeat contact routing changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'enable_sms_notifications'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} SMS notifications`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'enable_voicemail_notifications'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} voicemail notifications`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'enable_watcher_email_notifications'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} watcher email notifications`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_should_say_caller_position'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} caller position announcements`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_should_ask_for_callback'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} Offer callback`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_should_handle_by_text'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} Offer handle by text`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_should_ask_for_voicemail'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} voicemail requests`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_should_call_screen'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} call screening`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_send_voicemail_when_no_agents'
        },
        text: '`${change[1] ? \'Enabled\' : \'Disabled\'} voicemail when no agents`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_repeat_prompts_delay'
        },
        text: '`Queue repeat prompts delay changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong> seconds`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_ask_for_callback_tts'
        },
        text: '`Offer callback option text changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'description_changed'
    },
    {
        match: {
            attribute: 'queue_handle_by_text_tts'
        },
        text: '`Text option prompt changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'description_changed'
    },
    {
        match: {
            attribute: 'queue_handle_by_text_response_tts'
        },
        text: '`Text message to be sent changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'description_changed'
    },
    {
        match: {
            attribute: 'queue_ask_for_voicemail_tts'
        },
        text: '`Voicemail text changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'description_changed'
    },
    {
        match: {
            attribute: 'queue_call_screen_tts'
        },
        text: '`Press one message changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'call_handling_options'
        },
        text: '`<strong>Call handling options</strong> updated`',
        icon: 'edited'
    },
    {
        match: {
            attribute: 'queue_wait_music_file'
        },
        text: '`<strong>Wait music</strong> changed from <strong>${change[0]}</strong> to <strong>${change[1]}</strong>`',
        icon: 'edited'
    },
    {
        match: {
            event_type_generic: 'model_updated'
        },
        text: '`Inbox Attribute <strong>${attribute}</strong> changed`',
        icon: 'edited'
    }
]; 
